module.exports = __webpack_public_path__ + "static/media/hourglass.a7777ffd.svg";